import { switchTree } from '@fs/zion-tree-groups'
import { type GroupsValue } from '@fs/zion-tree-groups/dist/es/types/groups'
import { type Person } from '@fs/zion-tree-types'
import { useEffect } from 'react'

type Props = {
  focusPerson?: Person
} & Pick<Partial<GroupsValue>, 'currentTreeId' | 'selectTree' | 'isResearcherGroup'>

export default function useSwitchTree({ focusPerson, selectTree, currentTreeId, isResearcherGroup }: Props): void {
  useEffect(() => {
    switchTree({ focusPerson, selectTree, currentTreeId, isResearcherGroup })
  }, [currentTreeId, focusPerson, selectTree, isResearcherGroup])
}
